if (!customElements.get('video-artwork-finder')) {
  customElements.define('video-artwork-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const search = this.querySelector('[data-search]');
      const cards = [...this.querySelectorAll('[data-artwork-card]')];
      const recent = this.querySelector('[data-recent]');
      const count = this.querySelector('[data-count]');
      const empty = this.querySelector('[data-empty]');
      const clear = this.querySelector('[data-clear]');
      const topics = [...this.querySelectorAll('[data-topic]')];
      const normalise = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
      const entries = cards.map(card => ({card, raw: card.dataset.keywords.toLowerCase(), text: normalise(card.dataset.keywords)}));
      let selectedTopic = 'all';
      const update = () => {
        const words = normalise(search.value).split(' ').filter(Boolean);
        const filtering = words.length > 0 || selectedTopic !== 'all';
        let matches = 0;
        for (const entry of entries) {
          const match = words.every(word => entry.text.includes(word)) && (selectedTopic === 'all' || entry.raw.includes('topic:' + selectedTopic));
          entry.card.hidden = !match;
          if (match) matches++;
        }
        if (recent) recent.hidden = filtering;
        this.classList.toggle('is-filtering', filtering);
        count.textContent = this.dataset.countLabel.replace('__COUNT__', String(matches));
        empty.hidden = matches > 0;
        clear.hidden = !filtering;
        for (const button of topics) button.setAttribute('aria-pressed', String(button.dataset.topic === selectedTopic));
      };
      const reset = () => {
        selectedTopic = 'all';
        search.value = '';
        update();
        search.focus();
      };
      search.addEventListener('input', update);
      this.querySelector('form').addEventListener('submit', event => {event.preventDefault(); update();});
      clear.addEventListener('click', reset);
      this.querySelector('[data-reset]').addEventListener('click', reset);
      for (const button of topics) button.addEventListener('click', () => {selectedTopic = button.dataset.topic; update();});
      this.querySelector('[data-controls]').hidden = false;
      update();
    }
  });
}
